var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5298 3.46967C15.8227 3.76256 15.8227 4.23743 15.5298 4.53033L9.6512 10.409C9.6512 10.409 9.6512 10.409 9.6512 10.409C8.7725 11.2877 8.77254 12.7124 9.65119 13.591L9.65121 13.591L15.5298 19.4697C15.8227 19.7626 15.8227 20.2374 15.5298 20.5303C15.2369 20.8232 14.7621 20.8232 14.4692 20.5303L8.59056 14.6516C8.59055 14.6516 8.59055 14.6516 8.59054 14.6516C7.12605 13.1872 7.12609 10.8128 8.59053 9.34838L8.59053 9.34837L14.4692 3.46967C14.7621 3.17678 15.2369 3.17678 15.5298 3.46967Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.05edb84ed9cd47135fecebcd52b64ccb.svg";
export { ForwardRef as ReactComponent };